import { Button, Icon, Illustration, HStack } from '@genial/components';
import { Config } from '@genial/config';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';
import { Linking } from 'react-native';

export namespace SignedOutHeaderTypes {
  export interface Props {
    isMobile?: boolean;
  }
}

export const SignedOutHeader: React.FC<SignedOutHeaderTypes.Props> = ({ isMobile }) => {
  const handleHelp = async () => {
    const urlIsOpenable = await Linking.canOpenURL(Config.GenialSignupUrl);

    if (urlIsOpenable) {
      await Linking.openURL(Config.GenialSignupUrl);
    }
  };

  return (
    <>
      {isMobile ? (
        <HStack justifyContent="center" alignItems="center" width="100%" paddingTop="10%">
          <Illustration name="GenialFullBlue" width="130px" height="48px" />
        </HStack>
      ) : (
        <HStack
          justifyContent={{ md: 'space-evenly', lg: 'space-between' }}
          paddingX={Spacing['stack.md']}
          alignItems="center">
          <Illustration name="GenialFullLight" width="114px" height="50px" />
          <Button
            alignSelf="flex-end"
            variant="tertiary"
            background={'rgba(255, 255, 255, 0.50)'}
            _text={{
              color: 'neutral.black',
              fontWeight: 'semibold',
            }}
            onPress={handleHelp}
            padding={0}
            rightIcon={<Icon name="Headphone" color={Color['neutral.black']} size="xs" />}>
            PRECISA DE AJUDA?
          </Button>
        </HStack>
      )}
    </>
  );
};
